import React from "react";

const WastedDosesIcon = ({ width, height, color }) => {
  return (
    <svg
      width="43"
      height="54"
      viewBox="0 0 43 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.3846 6.75H33.0769C33.0769 3.02231 30.1149 0 26.4615 0H16.5385C12.8851 0 9.92308 3.02231 9.92308 6.75H6.61538C2.96204 6.75 0 9.77231 0 13.5V20.25L6.69312 51.3565C7.02885 52.9023 8.3726 54 9.92308 54H33.0769C34.6274 54 35.9712 52.9023 36.3073 51.3565L43 20.25V13.5C43 9.77231 40.038 6.75 36.3846 6.75ZM33.0769 50.625H9.92308L3.30769 20.25H39.6923L33.0769 50.625ZM39.6923 16.875H3.30769V13.5C3.30769 11.6378 4.79037 10.125 6.61538 10.125H13.2308V6.75C13.2308 4.88784 14.7134 3.375 16.5385 3.375H26.4615C28.2866 3.375 29.7692 4.88784 29.7692 6.75V10.125H36.3846C38.2096 10.125 39.6923 11.6378 39.6923 13.5V16.875ZM16.5385 10.125H26.4615V6.75H16.5385V10.125Z"
        fill="#435CFF"
      />
    </svg>
  );
};

export default WastedDosesIcon;
